import { prop, propArray, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { ZoneLine } from "./zone-line";
import { Country } from "../../common/_types/country";
import { CountryRegion } from "../../common/_types/country-region";

export class Zone extends Resource {
    public override type = 'zones';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public active: boolean = true;

    @prop()
    @required()
    public countryId?:string;
    
    @propObject()
    public country?: Country;

    @prop()
    @required()
    public countryRegionId?:string;
    
    @propObject()
    public countryRegion?: CountryRegion;
    
    @propArray()
    public zoneLines : ZoneLine[] =[];


}